import React from "react";
import "./styles.less";
import { useTranslation } from "react-i18next";
import { Title } from "../../components/NewTitle";
import { Link } from "react-router-dom";

export const HomeApplication = () => {
  const { t } = useTranslation();

  return (
    <div className="home-application">
      <div className="inner" style={{ position: "relative" }}>
        <div className="home-application-img">
          <img
            src="//files.authing.co/authing-website/home-apn-bg.png"
            alt="authing home-conection"
          />
        </div>
        <div className="home-application-title">
          <Title title={t("home.application.title")}>
            {t("home.application.subtitle")}
          </Title>
          <Link to="/apn" data-log="partners/apn">
            {t("home.application.toApn")}
            <i
              className="icon authing-icon authing-arrow-down-line arrow"
              style={{
                transform: "rotate(90deg)",
                display: "inline-block",
              }}
            ></i>
          </Link>
        </div>
      </div>
    </div>
  );
};
